const API_URL = process.env.REACT_APP_API_URL;

// Get all commitments (for admin)
export const getAllCommitments = async () => {
  try {
    const response = await fetch(`${API_URL}/api/commitments`);
    const data = await response.json();
    
    if (!response.ok) {
      throw new Error(data.message || 'Failed to fetch commitments');
    }
    
    return data.data;
  } catch (error) {
    throw error;
  }
};

// Get active commitments (for frontend)
export const getActiveCommitments = async () => {
  try {
    const response = await fetch(`${API_URL}/api/commitments/active`);
    const data = await response.json();
    
    if (!response.ok) {
      throw new Error(data.message || 'Failed to fetch active commitments');
    }
    
    return data.data;
  } catch (error) {
    throw error;
  }
};

// Get single commitment by ID
export const getCommitmentById = async (id) => {
  try {
    const response = await fetch(`${API_URL}/api/commitments/${id}`);
    const data = await response.json();
    
    if (!response.ok) {
      throw new Error(data.message || 'Failed to fetch commitment');
    }
    
    return data.data;
  } catch (error) {
    throw error;
  }
};

// Create new commitment
export const createCommitment = async (commitmentData) => {
  try {
    const response = await fetch(`${API_URL}/api/commitments`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(commitmentData),
    });
    
    const data = await response.json();
    
    if (!response.ok) {
      throw new Error(data.message || 'Failed to create commitment');
    }
    
    return data.data;
  } catch (error) {
    throw error;
  }
};

// Update commitment
export const updateCommitment = async (id, commitmentData) => {
  try {
    const response = await fetch(`${API_URL}/api/commitments/${id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(commitmentData),
    });
    
    const data = await response.json();
    
    if (!response.ok) {
      throw new Error(data.message || 'Failed to update commitment');
    }
    
    return data.data;
  } catch (error) {
    throw error;
  }
};

// Deactivate commitment
export const deactivateCommitment = async (id) => {
  try {
    const response = await fetch(`${API_URL}/api/commitments/${id}/deactivate`, {
      method: 'PATCH',
    });
    
    const data = await response.json();
    
    if (!response.ok) {
      throw new Error(data.message || 'Failed to deactivate commitment');
    }
    
    return data.data;
  } catch (error) {
    throw error;
  }
};

// Toggle commitment active status
export const toggleCommitmentActive = async (id) => {
  try {
    const response = await fetch(`${API_URL}/api/commitments/${id}/toggle-active`, {
      method: 'PATCH',
    });
    
    const data = await response.json();
    
    if (!response.ok) {
      throw new Error(data.message || 'Failed to toggle commitment active status');
    }
    
    return data.data;
  } catch (error) {
    throw error;
  }
};

// Delete commitment
export const deleteCommitment = async (id) => {
  try {
    const response = await fetch(`${API_URL}/api/commitments/${id}`, {
      method: 'DELETE',
    });
    
    const data = await response.json();
    
    if (!response.ok) {
      throw new Error(data.message || 'Failed to delete commitment');
    }
    
    return data.data;
  } catch (error) {
    throw error;
  }
};